// iSQROLL Tui Icons
// 10 general icons available to all users + 20 reward icons unlocked through milestones

export interface TuiIcon {
  id: string
  path: string
  tier: 'general' | 'earned'
  earnedLabel?: string
}

// ── General Icons (available to all users) ──────────────────────────────────

export const TUI_ICONS: TuiIcon[] = [
  { id: 'tui-icon-1', path: '/images/tui-icons/tui-icon-1.webp', tier: 'general' },
  { id: 'tui-icon-2', path: '/images/tui-icons/tui-icon-2.webp', tier: 'general' },
  { id: 'tui-icon-3', path: '/images/tui-icons/tui-icon-3.webp', tier: 'general' },
  { id: 'tui-icon-4', path: '/images/tui-icons/tui-icon-4.webp', tier: 'general' },
  { id: 'tui-icon-5', path: '/images/tui-icons/tui-icon-5.webp', tier: 'general' },
  { id: 'tui-icon-6', path: '/images/tui-icons/tui-icon-6.webp', tier: 'general' },
  { id: 'tui-icon-7', path: '/images/tui-icons/tui-icon-7.webp', tier: 'general' },
  { id: 'tui-icon-8', path: '/images/tui-icons/tui-icon-8.webp', tier: 'general' },
  { id: 'tui-icon-9', path: '/images/tui-icons/tui-icon-9.webp', tier: 'general' },
  { id: 'tui-icon-10', path: '/images/tui-icons/tui-icon-10.webp', tier: 'general' },
]

// ── Reward Icons (unlocked through gamification milestones) ─────────────────

export const TUI_REWARD_ICONS: TuiIcon[] = [
  { id: 'tui-reward-1', path: '/images/tui-rewards/tui-reward-1.webp', tier: 'earned' },
  { id: 'tui-reward-2', path: '/images/tui-rewards/tui-reward-2.webp', tier: 'earned' },
  { id: 'tui-reward-3', path: '/images/tui-rewards/tui-reward-3.webp', tier: 'earned' },
  { id: 'tui-reward-4', path: '/images/tui-rewards/tui-reward-4.webp', tier: 'earned' },
  { id: 'tui-reward-5', path: '/images/tui-rewards/tui-reward-5.webp', tier: 'earned' },
  { id: 'tui-reward-6', path: '/images/tui-rewards/tui-reward-6.webp', tier: 'earned' },
  { id: 'tui-reward-7', path: '/images/tui-rewards/tui-reward-7.webp', tier: 'earned' },
  { id: 'tui-reward-8', path: '/images/tui-rewards/tui-reward-8.webp', tier: 'earned' },
  { id: 'tui-reward-9', path: '/images/tui-rewards/tui-reward-9.webp', tier: 'earned' },
  { id: 'tui-reward-10', path: '/images/tui-rewards/tui-reward-10.webp', tier: 'earned' },
  { id: 'tui-reward-11', path: '/images/tui-rewards/tui-reward-11.webp', tier: 'earned' },
  { id: 'tui-reward-12', path: '/images/tui-rewards/tui-reward-12.webp', tier: 'earned' },
  { id: 'tui-reward-13', path: '/images/tui-rewards/tui-reward-13.webp', tier: 'earned' },
  { id: 'tui-reward-14', path: '/images/tui-rewards/tui-reward-14.webp', tier: 'earned' },
  { id: 'tui-reward-15', path: '/images/tui-rewards/tui-reward-15.webp', tier: 'earned' },
  { id: 'tui-reward-16', path: '/images/tui-rewards/tui-reward-16.webp', tier: 'earned' },
  { id: 'tui-reward-17', path: '/images/tui-rewards/tui-reward-17.webp', tier: 'earned' },
  { id: 'tui-reward-18', path: '/images/tui-rewards/tui-reward-18.webp', tier: 'earned' },
  { id: 'tui-reward-19', path: '/images/tui-rewards/tui-reward-19.webp', tier: 'earned' },
  { id: 'tui-reward-20', path: '/images/tui-rewards/tui-reward-20.webp', tier: 'earned' },
]

export const DEFAULT_TUI_ICON = TUI_ICONS[0]

/** Get a Tui icon by its ID — searches both general and reward arrays */
export function getTuiIconById(id: string): TuiIcon | undefined {
  return TUI_ICONS.find((icon) => icon.id === id)
    ?? TUI_REWARD_ICONS.find((icon) => icon.id === id)
}

/** Get icons available to general users (excluding earned) */
export function getGeneralIcons(): TuiIcon[] {
  return TUI_ICONS
}

/** Get earned/reward icons */
export function getEarnedIcons(): TuiIcon[] {
  return TUI_REWARD_ICONS
}
